import React from 'react'
import classes from "./StatusContainer.module.css";
const StatusContainer = ({label,ball

}) => {
  return (
    <>
    
    <span className={classes.wrapper}>
    {ball && ball}
      {label
    }</span>
    </>
  )
}

export default StatusContainer